const POPUP_REDUX_CONSTANT = {
  POP_UP_MESSAGE: 'POP_UP_MESSAGE',
};
export default POPUP_REDUX_CONSTANT;
